import { inject, observer } from 'mobx-react';

import Icon from 'bz-icons/src/controls/icon';
import Action from '../../../action-base';
import React from 'react';
import { computed } from 'mobx';
import ProntoReportStatus from 'bz-pronto-core/enum/pronto-report-status';

@inject('vm')
@observer
class EditAction extends React.Component {
  static defaultProps = {
    onEdit: () => {}
  };

  render() {
    if (!this.show) return null;

    let icon = <Icon width={16} height={16} value="0014_notebook_paper_todo" />;

    return <Action label="Edit" icon={icon} onClick={this.props.onEdit} />;
  }

  @computed
  get show() {
    let { status } = this.props.vm.report;
    return status === ProntoReportStatus.Saved;
  }
}

export default EditAction;
